/**
 * Client-side admin allow-list. This is purely for UX (hiding nav links and
 * guarding the route to avoid a flash of admin chrome). The real authorisation
 * happens server-side in the `verifyAdmin` decorator — the API returns 403 for
 * non-admins regardless of what the client thinks. Keep this in sync with the
 * server's ADMIN_EMAILS default.
 */
const ADMIN_EMAILS = ['ccarswell66@gmail.com'];

export function isAdminEmail(email?: string | null): boolean {
  return !!email && ADMIN_EMAILS.includes(email.toLowerCase());
}
